import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { isMobilePage } from 'lib/util/helpers';

/**
 * Scroll Element implemntation.
 *
 * @author Kiril Delovski
 * @extends Tc.Module
 */
export default class ScrollElement extends Module {

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 * @author Kiril Delovski
	 */

	public on(callback : Hook) {
		const $ctx = this.$ctx;
		const $slideElements = $ctx.find('.slide');
		const slideElementsLength = $slideElements.length;
		const $firstSlideImage = $ctx.find('.slide-1 .image-presenter');

		if (slideElementsLength > 1) {
			let slide1TopPosition = $firstSlideImage.position().top;
			let elHeight = $firstSlideImage.height() || 0;
			let elWidth = $firstSlideImage.width() || 0;
			const $slideImages = $slideElements.find('.image-presenter');
			const $lastSlideElem = $($slideElements[slideElementsLength - 1]);
			const $lastSlideImage = $lastSlideElem.find('.image-presenter');

			$firstSlideImage.css('opacity', 1);
			$slideImages.css('height',  elHeight);
			$slideImages.css('width',  elWidth);

			window.addEventListener('scroll', eventScrolling, {passive: true});
			window.addEventListener('resize', function() {
				slide1TopPosition = $ctx.find('.slide-1 .image').position().top;
				elHeight = $firstSlideImage.height() || 0;
				elWidth = $firstSlideImage.width() || 0;
			}, {passive: true});

			function eventScrolling() {
				const $window = $(window);
				const mobileLandscape =  window.innerHeight < window.innerWidth;
				let topMargin;
				const windowHeight = $window.height() || 1;
				const scrollPosition = $window.scrollTop() || 0;
				const scroll = scrollPosition + (windowHeight / 3);

				if(isMobilePage()) {
					if(window.innerWidth <= 768) {
						topMargin = 0;
					} else {
						topMargin = 160;
						if(mobileLandscape) {
							topMargin = 100;
						}
					}
				} else {
					topMargin = 160;
				}

				if(scrollPosition + topMargin > slide1TopPosition) {
					$firstSlideImage.css('opacity', '');
					$slideImages.addClass('fixed');
				}

				if($lastSlideElem.position().top < scrollPosition + topMargin) {
					$slideImages.removeClass('fixed');

					if (!$lastSlideElem.hasClass('active') && !$lastSlideImage.hasClass('fixed')) {
						$lastSlideImage.css('opacity', 1);
					} else {
						$lastSlideImage.css('opacity', '');
					}
				}

				if(scrollPosition + topMargin < slide1TopPosition) {
					$firstSlideImage.css('opacity', 1);
					$slideImages.removeClass('fixed');
				}

				$slideElements.removeClass('active');

				$slideElements.each(function() {
					const $this = $(this);

					if ($this.position().top <= scroll && $this.position().top + ($this.height() || 1) > scroll) {
						$this.addClass('active');
					}
				});
			}
		}
		callback();
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/scrollElement/Tc.Module.ScrollElement.ts